import { render } from "./Ecom.vue?vue&type=template&id=b4d2ef10"
import script from "./Ecom.vue?vue&type=script&lang=js"
export * from "./Ecom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__